import { render, staticRenderFns } from "./tabBookingFCL.vue?vue&type=template&id=bdb252fe&scoped=true&"
import script from "./tabBookingFCL.vue?vue&type=script&lang=js&"
export * from "./tabBookingFCL.vue?vue&type=script&lang=js&"
import style0 from "./tabBookingFCL.vue?vue&type=style&index=0&id=bdb252fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb252fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdb252fe')) {
      api.createRecord('bdb252fe', component.options)
    } else {
      api.reload('bdb252fe', component.options)
    }
    module.hot.accept("./tabBookingFCL.vue?vue&type=template&id=bdb252fe&scoped=true&", function () {
      api.rerender('bdb252fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirImport/components/booking/tabs/tabBookingFCL.vue"
export default component.exports